
import axios from 'axios';
import AWS from 'aws-sdk';
import mime from 'mime-types';
import uuidv4 from 'uuid/v4';
import fetch from '../utils/Api';
import slugify from '../utils/slugify';
import {
  API_BASE_URL,
  AUTH_TOKEN_KEY,
  CREATE_SKU_REQUEST,
  UPDATE_SKU_REQUEST
} from '../constants/';


const SKUREQUEST_RESOURE_URL = 'v2/products/sku_requests'

const fetchApi = () => fetch({
  Authorization:'Bearer '+ localStorage.getItem(AUTH_TOKEN_KEY),
  'Content-Type': 'multipart/form-data'
})

const doCreateSkuRequest = (payloads) => {
  let formData = new FormData();
  Object.keys(payloads).map(key => {
    formData.append(key, payloads[key])    
  })
  return {
    type: CREATE_SKU_REQUEST,
    payload: fetchApi().post(`${SKUREQUEST_RESOURE_URL}`, formData)
      .then(r => r.data)
  }
}

const doUpdateSkuRequest = (id, payloads) => {
  let formData = new FormData();
  Object.keys(payloads).map(key => {
    formData.append(key, payloads[key])    
  })
  return {
    type: UPDATE_SKU_REQUEST,
    payload: fetchApi().put(`${SKUREQUEST_RESOURE_URL}/${id}`, payloads)
      .then(r => r.data)
  }
}

export const doSaveSkuRequest = (payloads, id = null) => (
  dispatch => {
    if(id) return dispatch(doUpdateSkuRequest(id, payloads))
    return dispatch(doCreateSkuRequest(payloads))
  }
)

export const doUploadSkuImage = (id, prefix, file) => dispatch => {
  // const rootFolder = `sku-requests/${prefix}`;
  // const bucketName = document.location.hostname.indexOf("www.kickavenue.com") !== -1 ? BUCKET_NAME_USER : BUCKET_NAME_DEV;
  // const resourcesURL = document.location.hostname.indexOf("www.kickavenue.com") !== -1 ? RESOURCE_URL_USER : RESOURCE_URL_DEV;
  // const uuid = uuidv4();
  // const filename=`${slugify((file.name.substr(0, file.name.lastIndexOf('.'))||file.name))}-${uuid.substr(0,uuid.indexOf('-'))}`;
  // const key = `${rootFolder}${filename}.${mime.extension(file.type)}`;
  // s3().putObject({
  //   Bucket: bucketName,
  //   Key: key,
  //   Body: file,
  //   ContentType: mime.lookup(file.name),
  //   ACL: 'public-read'
  // }, err => {
  //   if(err){
  //     console.log("Cannot upload images...")
  //   }
  //   return dispatch(
  //     doSaveSkuRequest({ img_url: `${resourcesURL}${key}` }, id)
  //   );
  // })
}